import React, { useContext } from 'react';
import { SwiperOptions } from 'swiper';
import 'swiper/css';
import { Swiper, SwiperSlide } from 'swiper/react';
import { PageColorCtx } from '../../../helpers/shareContext';
import { useMobile } from '../../../hook/useMobile';
import { BACKGROUND_COLOR } from '../../../shared/colors';
import { Article } from '../../../types/Article';
import SingleImage from '../../single-image/single-image';
import styles from './article-thumbnails.module.scss';

export interface Props {
  articles: Article[];
  currentArticleTitle: string;
  hoverColor?: BACKGROUND_COLOR;
}

const ArticleThumbnails = (props: Props) => {
  const { articles, currentArticleTitle, hoverColor } = props;
  const { pageColorCtx } = useContext(PageColorCtx);

  const isMobile = useMobile();
  const swiperOption: SwiperOptions = {
    slidesPerView: 'auto',
    spaceBetween: 20,
  };
  const renderArticleThumbnailItem = (article: Article) => {
    return (
      <SwiperSlide className={styles.articleItem} key={article.articleUrl}>
        <SingleImage
          imageUrl={article?.leadImage || ''}
          imageHref={article?.articleUrl}
          colorless
          tagPosition="top"
          tag={article.categories[0]}
          ratio={isMobile ? [250, 237] : [314, 237]}
          borderRadius={10}
          tagSize="normal"
          shape="square"
          hoverBorderColor={
            (pageColorCtx as BACKGROUND_COLOR) || hoverColor
          }
        />
        <p className={styles.articleTitle}>{article.title}</p>
        <div
          className={styles.articleDescription}
          dangerouslySetInnerHTML={{
            __html: article.description,
          }}
        ></div>
      </SwiperSlide>
    );
  };
  return (
    <div className={styles.articleThumbnails}>
      <p className={styles.articleThumbnailsTitle}>{currentArticleTitle}</p>
      <div className={styles.articleSwiperWrapper}>
        <Swiper className={styles.articleSwiperContainer} {...swiperOption}>
          {articles.map((article: Article) =>
            renderArticleThumbnailItem(article)
          )}
        </Swiper>
      </div>
    </div>
  );
};

export default ArticleThumbnails;
